var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('LogoImg'),_c('NavBar'),_c('NavMobile'),_c('GradientMap'),_c('IconText',{attrs:{"blockContent":_vm.privacy_policy,"buttonContent":_vm.no_button}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }